import { useTranslation } from "@redotech/redo-i18n";
import { FlowType } from "@redotech/redo-return-core-common/return-flow-enums";
import { memo, useMemo } from "react";
import { htmlMessageFieldSpec } from "./field-specs";
import { StepTranslationLanguages } from "./step-translation-languages";
import { stepElementIdsOf, StepTranslationElement } from "./step-translations";
import { TranslatableTextareaField } from "./translatable-textarea-field";

export interface MessageStepTranslationFieldsProps {
  canEdit: boolean;
  elementId: string | undefined;
  flowType: FlowType;
  message: string;
  placeholder: string;
  setMessage(message: string): void;
}

export const MessageStepTranslationFields = memo(
  function MessageStepTranslationFields({
    canEdit,
    elementId,
    flowType,
    message,
    placeholder,
    setMessage,
  }: MessageStepTranslationFieldsProps) {
    const { t } = useTranslation();
    const field = useMemo(() => htmlMessageFieldSpec(message), [message]);
    const translationElements = useMemo<StepTranslationElement[]>(
      () => [{ elementId, field }],
      [elementId, field],
    );
    const stepElementIds = useMemo(
      () => stepElementIdsOf(translationElements),
      [translationElements],
    );

    return (
      <>
        <StepTranslationLanguages
          canEdit={canEdit}
          elements={translationElements}
          flowType={flowType}
        />
        <TranslatableTextareaField
          canEdit={canEdit}
          elementId={elementId}
          field={field}
          flowType={flowType}
          helperText={t("Message to show to the customer. Can include HTML.")}
          placeholder={placeholder}
          setValue={setMessage}
          stepElementIds={stepElementIds}
        />
      </>
    );
  },
);
